import script from "./Interview.vue?vue&type=script&lang=ts&setup=true"
export * from "./Interview.vue?vue&type=script&lang=ts&setup=true"

import "./Interview.vue?vue&type=style&index=0&id=563806b6&lang=less"

const __exports__ = script;

export default __exports__